import { render, staticRenderFns } from "./Rimborsi.vue?vue&type=template&id=c4dcb8f8&scoped=true&"
import script from "./Rimborsi.vue?vue&type=script&lang=js&"
export * from "./Rimborsi.vue?vue&type=script&lang=js&"
import style0 from "./Rimborsi.vue?vue&type=style&index=0&id=c4dcb8f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dcb8f8",
  null
  
)

export default component.exports